import React, { useState, useEffect } from 'react'
import {
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@mui/material'

import {
  Card,
  Grid,
  Span,
  Row,
  Button
} from 'components'
import { SPACING, COLORS } from 'utils'
import { ArrowLeftIcon, ArrowRigthIcon } from 'components/Icons'
import { SemValidacao, ComValidacao, ValidacaoTecnicaServices } from 'services/GST/Parameterization'
import { IResponseTypes } from 'services/core/genericEntityGST'
import { useLoading, useModal, useException } from 'hooks'

import { IconsContainer } from 'pages/Supplier/Users/CollaboratorContract/components/CardContracts/styles'

const ValidacaoTecnica: React.FC = () => {
  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const { getException, createCustomException } = useException()

  const [centroPlantaComValidacao, setCentroPlantaComValidacao] = useState<ComValidacao[]>([])
  const [centroPlantaSemValidacao, setCentroPlantaSemValidacao] = useState<SemValidacao[]>([])

  const getAllCentrosPlanta = () => {
    setLoading('loading')

    ValidacaoTecnicaServices()
      .getAllCentrosPlanta()
      .then(response => {
        if (response.status !== 200) {
          const { tipo, detalhe, mensagem } = response.data

          createCustomException({
            tipo: response.status === 204 ? 'alert' : IResponseTypes[tipo],
            mensagem: response.status === 204 ? 'Não foi encontrado nenhum Centro Planta' : mensagem,
            detalhe,
          })
        }

        if (response?.data?.entity) {
          setCentroPlantaComValidacao(response.data.entity.comValidacao)
          setCentroPlantaSemValidacao(response.data.entity.semValidacao)
        }

        setLoading('idle')
      })
      .catch((err: Error) => {
        setLoading('idle')
        const error = getException(err)

        showModal({
          type: error.tipo,
          message: error.mensagem,
          hideButtonCancel: true,
          txtButtonConfirm: 'OK',
        })
      })
  }

  const handleCheckCentroPlanta = (selectedCentroPlanta: SemValidacao | ComValidacao, index: number) => {
    if (selectedCentroPlanta.flNecessitaValidacao) {
      centroPlantaComValidacao[index].isChecked = !centroPlantaComValidacao[index].isChecked
      setCentroPlantaComValidacao([...centroPlantaComValidacao])
    } else {
      centroPlantaSemValidacao[index].isChecked = !centroPlantaSemValidacao[index].isChecked
      setCentroPlantaSemValidacao([...centroPlantaSemValidacao])
    }
  }

  const handleSave = () => {
    setLoading('loading')

    ValidacaoTecnicaServices()
      .AtualizarFlagValidacao({
        comValidacaoUpdate: centroPlantaComValidacao.map(centro => centro.idCentroPlanta),
        semValidacaoUpdate: centroPlantaSemValidacao.map(centro => centro.idCentroPlanta),
      })
      .then(response => {
        if (response.status === 204) {
          showModal({
            type: 'success',
            message: 'Os dados foram salvos com sucesso!',
            hideButtonCancel: true,
            txtButtonConfirm: 'OK',
          })
          setLoading('idle')
          return
        }

        if (response.status !== 200) {
          const { tipo, mensagem, detalhe } = response.data

          createCustomException({
            tipo: IResponseTypes[tipo],
            mensagem: mensagem,
            detalhe
          })
        }

        setLoading('idle')
      })
      .catch((err: Error) => {
        setLoading('idle')
        const error = getException(err)

        showModal({
          type: error.tipo,
          message: error.mensagem,
          hideButtonCancel: true,
          txtButtonConfirm: 'OK',
        })
      })
  }

  const handleMoveItensToRightCard = () => {
    centroPlantaSemValidacao.map(centro => {
      if (centro.isChecked) {
        setCentroPlantaComValidacao(prevState => [...prevState, centro])
      }
    })

    setCentroPlantaSemValidacao([...centroPlantaSemValidacao.filter((centro) => !centro.isChecked)])
  }

  const handleMoveItensToLeftCard = () => {
    centroPlantaComValidacao.map(centro => {
      if (centro.isChecked) {
        setCentroPlantaSemValidacao(prevState => [...prevState, centro])
      }
    })

    setCentroPlantaComValidacao([...centroPlantaComValidacao.filter(centro => !centro.isChecked)])
  }

  useEffect(() => {
    getAllCentrosPlanta()
  }, [])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
      borderRadius={`0px 10px 0px 0px`}
    >
      <Grid
        gridCols="6fr 0.1fr 6fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Card
          boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
          borderRadius="10px 10px"
          marginTop={SPACING.spacing15}
          maxHeight="400px"
        >
          <Card
            backgroundColor={COLORS.primary}
            borderRadius="10px 10px 0px 0px"
            padding={SPACING.spacing10}
          >
            <Span
              text="Centro Planta SEM Validação Técnica"
              fontWeight="400"
              fontSize="18px"
              textAlign='center'
            />
          </Card>
          <div style={{
            height: 400,
            padding: 10,
            overflowY: 'scroll',
          }}>
            <FormGroup>
              {centroPlantaSemValidacao.map((centroPlanta: SemValidacao, index) => (
                <FormControlLabel
                  key={centroPlanta.idCentroPlanta}
                  control={<Checkbox value={centroPlanta.isChecked} onClick={() => handleCheckCentroPlanta(centroPlanta, index)} />}
                  label={centroPlanta.txDescricaoCentroPlanta}
                />
              ))}
            </FormGroup>
          </div>
        </Card>

        <IconsContainer style={{ marginTop: '2rem' }}>
          <ArrowRigthIcon
            marginBottom={SPACING.spacing50}
            colorIcon={COLORS.blueFonts}
            onClick={handleMoveItensToRightCard}
          />
          <ArrowLeftIcon
            colorIcon={COLORS.blueFonts}
            onClick={handleMoveItensToLeftCard}
          />
        </IconsContainer>

        <Card
          boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
          borderRadius="10px 10px"
          marginTop={SPACING.spacing15}
          maxHeight="400px"
        >
          <Card
            backgroundColor={COLORS.primary}
            borderRadius="10px 10px 0px 0px"
            padding={SPACING.spacing10}
          >
            <Span
              text="Centro Planta COM Validação Técnica"
              fontWeight="400"
              fontSize="18px"
              textAlign='center'
            />
          </Card>

          <div style={{
            height: 400,
            padding: 10,
            overflowY: 'scroll',
          }}>
            <FormGroup>
              {centroPlantaComValidacao.map((centroPlanta: ComValidacao, index) => (
                <FormControlLabel
                  key={centroPlanta.idCentroPlanta}
                  control={<Checkbox value={centroPlanta.isChecked} onClick={() => handleCheckCentroPlanta(centroPlanta, index)} />}
                  label={centroPlanta.txDescricaoCentroPlanta}
                />
              ))}
            </FormGroup>
          </div>
        </Card>

      </Grid>
      <Row justifyContent="flex-end">
        <Button
          text="Salvar"
          onClick={handleSave}
        />
      </Row>
    </Card>
  )
}

export default ValidacaoTecnica
